export enum TemplateType {
  SSR = 3,
  TSA = 4,
  TSANOADMIN = 2,
}
